import React from 'react';
import { Auth, I18n } from 'aws-amplify';
import { AmplifyTheme, 
        FederatedSignIn,
        FormSection,
        SectionBody,
        FederatedButtons,
        // eslint-disable-next-line
        withAuthenticator,
} from 'aws-amplify-react';
import CssBaseline from '@material-ui/core/CssBaseline';
import login from './img/smartdevice-img.png';
import "./smartdevice.css";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Link from "@material-ui/core/Link";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const styles = {
//   root: {
//     color: green[600],
//     '&$checked': {
//       color: green[500],
//     },
//   },
  dummy_button: {
      borderTop: '1px solid #ccc',
  },
  checked: {},
// 　appBar: {
//     position: 'relative',
//   },
  flex: {
    flex: 1,
  },
};



function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ThetaFederatedSignIn extends FederatedSignIn {
    
  state = {
    isAgreed:false,
    open:false,
  };
  
  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };
  
  handleOpen = () => {
      this.setState({ open: true });
  };
  
  handleClose = (item) => {
      this.setState({ open: false });
  };
    
        render() {
        const { classes } = this.props;   
            
        const { authState, onStateChange } = this.props;
        let federated = this.props.federated || {};
        const config = Auth.configure();
        if (config.oauth) {
            federated.oauth_config = Object.assign({}, federated.oauth_config, config.oauth);
        }

        if (!federated) {
            return null;
        }
        if (!['signIn', 'signedOut', 'signedUp'].includes(authState)) { return null; }
        const theme = this.props.theme || AmplifyTheme;
        return (
            <div className="center">
            <div className="header"><p className="title">{I18n.get("Login")}</p></div>
            <div className="privacy_policy_link">
              <Link
              href="https://info.theta-smartdevice.ricoh"
              >
              {I18n.get("privacy policy")}
              </Link>
              {I18n.get("agree privacy policy")}
            </div>
            <div className="privacy_policy">
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.isAgreed}
                  onChange={this.handleChange('isAgreed')}
                  value="isAgreed"
                  color="primary"
                  classes={{
                    // root: classes.root,
                    checked: classes.checked,
                  }}
                />
              }
              label= {I18n.get("agree privacy policy checkbox")}
            />
            </div>
            <Dialog
              fullScreen
              open={this.state.open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
            >
                <Toolbar>
                  <IconButton color="inherit" onClick={this.handleClose} aria-label="Close">
                    <CloseIcon />
                  </IconButton>
                  <Typography variant="h6" color="inherit" className={classes.flex}>
                    label= {I18n.get("privacy policy")}
                  </Typography>
                </Toolbar>
            </Dialog>
            
            <div className="login_button" style={{ display: this.state.isAgreed ? 'block' : 'none' }}>
            <FormSection theme={theme}>
                <SectionBody theme={theme}>
                    <CssBaseline/>
                    <FederatedButtons
                        federated={federated}
                        theme={theme}
                        authState={authState}
                        onStateChange={onStateChange}
                        target="_top"
                    />     
                </SectionBody>
            </FormSection>
            </div>
            <div className="anti_margin" style={{ display: this.state.isAgreed ? 'none' : 'block' }}>
            <div className="dummy_button" style={{ display: this.state.isAgreed ? 'none' : 'block' }}>
            <List disablePadding={true}>
                  <ListItem
                    role={undefined}
                    dense
                    button
                    divider={true}
                    disabled={true}
                    className=""
                    style={{ borderTop: '1px solid #ccc',padding:'6px 12px',borderBottom: '2px solid #ccc' }} 
                    >
                    <ListItemText 
                    className="dummy_button_text"
                    disableTypography
                    style={{ padding:'0px' }}
                    primary={<Typography type="body2" style={{ color: '#808080',fontSize:'14px' }}  ><p className="">Sign In with Google</p></Typography>}
                    />
                  </ListItem>
                  <ListItem
                    role={undefined}
                    dense
                    button
                    divider={true}
                    disabled={true}
                    className=""
                    style={{ borderTop: '1px solid #ccc',padding:'6px 12px',borderBottom: '2px solid #ccc' }} 
                  >
                  <ListItemText 
                  className="dummy_button_text"
                  disableTypography
                  style={{ padding:'0px' }}
                  primary={<Typography type="body2" style={{ color: '#808080',fontSize:'14px' }}  ><p className="">Sign In with Facebook</p></Typography>}
                  />
                  </ListItem>
                  <ListItem
                    role={undefined}
                    dense
                    button
                    divider={true}
                    disabled={true}
                    className=""
                    style={{ borderTop: '1px solid #ccc',padding:'6px 12px' }} 
                  >
                  <ListItemText 
                  className="dummy_button_text"
                  disableTypography
                  style={{ padding:'0px' }}
                  primary={<Typography type="body2" style={{ color: '#808080',fontSize:'14px' }}  ><p className="">Sign In with Amazon</p></Typography>}
                  />
                  </ListItem>
                </List>
            </div>
            </div>
            
            <div className="image">
            <img src={login} alt="login" />
            </div>
          
            </div>
        );
    }
}

export default withStyles(styles)(ThetaFederatedSignIn);



// WEBPACK FOOTER //
// ./src/components/ThetaFederatedSignIn.js